import { Heading } from "@/components";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { cn } from "@/lib/utils";
import { DistributionRulesByGL } from "./DistributionRulesByGL";
import { DistributionRulesByLevel } from "./DistributionRulesByLevel";
import { RULE_TAB_GL, RULE_TAB_LEVEL } from "./consts";
import useDistributionRuleConfiguration from "./useDistributionRuleConfiguration";

const DistributionRuleConfiguration = () => {
  const {
    activeRuleTab,
    breadcrumbData,
    isMobile,
    onRuleTabValueChange,
    ruleTabs,
    year,
    title
  } = useDistributionRuleConfiguration();

  return (
    <div className="p-4 md:p-6">
      <div className="mb-4 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title={title} breadcrumbData={breadcrumbData} />
        <div className="text-xl md:text-2xl font-semibold leading-none text-primary">
          {year}
        </div>
      </div>

      <Tabs
        value={activeRuleTab}
        onValueChange={onRuleTabValueChange}
        className="w-full"
      >
        <TabsList
          className={cn(
            "gap-x-4",
            isMobile ? "!w-full !overflow-x-scroll" : ""
          )}
        >
          {ruleTabs.map((tab: any) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="data-[state=active]:shadow-none hover:cursor-pointer text-gray-400 hover:text-primary px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value={RULE_TAB_LEVEL} className="w-full">
          <DistributionRulesByLevel />
        </TabsContent>
        <TabsContent value={RULE_TAB_GL} className="w-full">
          <DistributionRulesByGL />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default DistributionRuleConfiguration;
